import Welton71 from '../../../Media/BSD/Hiera/Welton 7.webp'
import Welton72 from '../../../Media/BSD/Hiera/Welton 7.webp'





const Welton7images =[
Welton71,Welton72
]

export default Welton7images;